import api from '../../services/api'
import { IStripeConfig } from '../types/Stripe'

export const StripeController = {
  getConfig: async (): Promise<IStripeConfig> => {
    const { data } = await api.get<IStripeConfig>('/stripe/config')
    return data
  },
}
